import React, { useEffect, useState } from "react"

const isBrowser = typeof window !== "undefined"

const AnalyticsDashboard = () => {
  const [analyticsData, setAnalyticsData] = useState({
    totalActiveUsers: null,
    totalEventCount: null,
    totalPageViewUsers: null,
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!isBrowser) return

    const fetchAnalytics = async () => {
      try {
        // Use the environment variable for the API URL
        const response = await fetch(process.env.GATSBY_GOOGLE_API_URL)
        if (!response.ok) throw new Error("Failed to fetch analytics")
        const data = await response.json()
        setAnalyticsData(data)
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchAnalytics()
  }, [])

  if (loading) return <div>Loading analytics data...</div>
  if (error) return <div>Error: {error}</div>

  const str1 = analyticsData.totalEventCount
  const str2 = analyticsData.totalPageViewUsers

  const arr1 = Array.from(String(str1), Number)
  const arr2 = Array.from(String(str2), Number)

  return (
    <div className="text-white flex lg:flex-row flex-col gap-5">
      <div>
        <p className="poppins-regular">Total visited pages</p>
        <div className="flex">
          {arr1.map((event) => (
            <p className="bg-white px-1 text-black border border-[#252529] poppins-regular">
              {event}
            </p>
          ))}
        </div>
      </div>
      <div>
        <p className="poppins-regular">Total visited users</p>
        <div className="flex">
          {arr2.map((view) => (
            <p className="bg-white px-1 text-black border border-[#252529] poppins-regular">
              {view}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AnalyticsDashboard
